import isEqual from 'lodash/isEqual';
import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase';
import PropTypes from 'prop-types';

class RSVPForm extends React.Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    rsvp: PropTypes.object,
    firebase: PropTypes.object.isRequired,
  };

  static defaultProps = {
    rsvp: {},
  };

  constructor(props) {
    super(props);
    this.memberRef = {};
    this.state = {
      ...this.updateState(props),

      shouldFocus: false,
      showForm: true,
      success: false,
      errors: {},
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(this.props.rsvp, nextProps.rsvp)) {
      this.setState({
        ...this.updateState(nextProps),
      });
    }
  }

  onNewMember = (e) => {
    const { group } = this.state;
    const groupLength = Object.keys(group).length;
    this.setState({
      group: {
        ...group,
        [groupLength]: e.target.value,
      },
      shouldFocus: true,
    });
  };

  onChange = (e, originalKey) => {
    let key = originalKey;
    let { value } = e.target;
    if (key === 'contactNumber') {
      value = value.replace(/[^0-9 +]/g, '');
    }
    if (key.includes('member')) {
      key = 'group';

      const idx = originalKey.split('-')[1];
      value = {
        ...this.state.group,
        [idx]: value,
      };
    }
    this.setState({ [key]: value });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { firebase, auth, profile: { displayName, email } } = this.props;
    const {
      contactNumber, songs, message, group,
    } = this.state;
    if (contactNumber.length === 0) {
      this.setState({ errors: { contactNumber: 'This field is required.' } });
      return;
    }

    const rsvp = {
      displayName,
      email,
      contactNumber,
      songs,
      message,
      group: Object
        .keys(group)
        .filter(key => !!group[key])
        .reduce((obj, key) => ({ ...obj, [key]: group[key] }), {}),
    };

    firebase
      .ref(`rsvp/${auth.uid}`)
      .set(rsvp)
      .then(() => {
        this.setState({
          ...rsvp,
          success: true,
          showForm: false,
        });
      });
  };

  setMemberRef = (ref, key) => {
    if (this.state.shouldFocus && !this.memberRef[key]) {
      this.memberRef[key] = ref;
      this.setState({
        shouldFocus: false,
      }, () => {
        const memberRef = this.memberRef[key];
        memberRef.focus();
        memberRef.selectionStart = 1;
        memberRef.selectionEnd = 1;
      });
    }
  };

  updateState = ({ rsvp }) => ({
    contactNumber: (rsvp && rsvp.contactNumber) || '',
    songs: (rsvp && rsvp.songs) || '',
    message: (rsvp && rsvp.message) || '',
    group: (rsvp && rsvp.group) || {},

    showForm: !rsvp,
    success: !!rsvp,
  });

  showForm = () => this.setState({ showForm: true });

  render() {
    const { profile } = this.props;
    const {
      contactNumber, songs, message, group, showForm, success, errors,
    } = this.state;

    const groupKeys = Object.keys(group);

    return (
      <div>
        {success &&
          <div>
            <div className="alert alert-success fade in" role="alert">
              <p>
                Thank you and see you on our wedding!
                <span role="img" aria-label="smiley">😁</span>
              </p>
            </div>
            {!showForm &&
              <button className="button" type="button" onClick={this.showForm}>Change RSVP</button>
            }
          </div>
        }
        {showForm &&
          <form onSubmit={this.onSubmit}>
            <div className="form-horizontal">
              <div className="form-group">
                <label htmlFor="name" className="col-xs-3 control-label">Name</label>
                <div className="col-xs-9">
                  <input
                    id="name"
                    className="form-control"
                    type="text"
                    value={profile.displayName}
                    disabled
                  />
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="email" className="col-xs-3 control-label">Email</label>
                <div className="col-xs-9">
                  <input
                    id="email"
                    className="form-control"
                    type="email"
                    value={profile.email}
                    disabled
                  />
                </div>
              </div>
              <div className={`form-group has-feedback ${errors.contactNumber ? 'has-error' : ''}`}>
                <label htmlFor="name" className="col-xs-3 control-label required">Number</label>
                <div className="col-xs-9">
                  <input
                    id="number"
                    className="form-control"
                    type="tel"
                    value={contactNumber}
                    onChange={e => this.onChange(e, 'contactNumber')}
                  />
                  {errors.contactNumber &&
                    <span className="glyphicon glyphicon-remove form-control-feedback" aria-hidden></span>
                  }
                  {errors.contactNumber &&
                    <span id="nameStatus" className="help-block">{errors.contactNumber}</span>
                  }
                </div>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="songs" className="control-label">
                Suggest a song for reception:
              </label>
              <textarea
                id="songs"
                className="form-control"
                rows="3"
                value={songs}
                onChange={e => this.onChange(e, 'songs')}
              />
            </div>
            <div className="form-group">
              <label htmlFor="message" className="control-label">
                Message:
              </label>
              <textarea
                id="message"
                className="form-control"
                rows="3"
                value={message}
                onChange={e => this.onChange(e, 'message')}
              />
            </div>
            <div className="form-group">
              <label htmlFor="group" className="control-label">
                I'm with:
              </label>
              {groupKeys.map(key => (
                <input
                  ref={ref => this.setMemberRef(ref, key)}
                  key={key}
                  id={`member-${key}`}
                  className="form-control"
                  value={group[key]}
                  onChange={e => this.onChange(e, `member-${key}`)}
                />
              ))}
              {groupKeys.length < 5 &&
                <input
                  key={groupKeys.length}
                  id={`member-${groupKeys.length}`}
                  className="form-control"
                  value=""
                  onChange={this.onNewMember}
                />
              }
            </div>
            <input type="submit" value="Submit" className="btn btn-default" />
          </form>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { firebase: { auth, profile, data: { rsvp: rsvpData } } } = state;
  return {
    auth,
    profile,
    rsvp: rsvpData && rsvpData[auth.uid],
  };
};

export default compose(
  firebaseConnect((_, store) => {
    const { firebase: { auth } } = store.getState();
    return [
      `rsvp/${auth.uid}`,
    ];
  }),
  connect(mapStateToProps),
)(RSVPForm);




// WEBPACK FOOTER //
// ./src/components/RSVPPage/RSVPForm.js